import { Controller } from "@hotwired/stimulus"

const PREFIX = "KLIENTR_FB_"

export default class extends Controller {
  static values = { identityUrl: String, brandColor: String, side: { type: String, default: "left" } }

  connect() {
    this.expanded = false
    this.parentOrigin = this.referrerOrigin()
    this.onMessage = this.onMessage.bind(this)
    window.addEventListener("message", this.onMessage)
    this.post("READY", { color: this.brandColorValue, side: this.sideValue })
  }

  disconnect() {
    window.removeEventListener("message", this.onMessage)
  }

  close() {
    this.expanded = false
    this.post("RESIZE", { width: "40px", height: "148px", expanded: false })
  }

  onMessage(event) {
    if (event.source !== window.parent) return
    if (this.parentOrigin && event.origin !== this.parentOrigin) return
    if (!event.data || typeof event.data.type !== "string") return
    if (!event.data.type.startsWith(PREFIX)) return

    const type = event.data.type.slice(PREFIX.length)
    const payload = event.data.payload || {}

    if (type === "TOGGLE") {
      this.expanded = Boolean(payload.expanded)
      return
    }

    if (type === "SET_USER_DATA") this.setUserData(payload)
  }

  async setUserData(payload) {
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    await fetch(this.identityUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": csrf
      },
      body: JSON.stringify({
        name: payload.name,
        email: payload.email,
        hmac: payload.hmac
      })
    })
  }

  post(type, payload = {}) {
    window.parent.postMessage({ type: PREFIX + type, payload }, this.parentOrigin || "*")
  }

  referrerOrigin() {
    try {
      return document.referrer ? new URL(document.referrer).origin : null
    } catch (_error) {
      return null
    }
  }
}
